import { AttributeFeatureType } from './../../../types/project-config';
import { StatefulCSS } from './../../../model/stateful_css';
import { ModalMessagerService } from './../../dialogs/modal-messager/modal-messager.service';
import { ObjID } from './../../../model/id-manager';
import { ProjectConfigUtil } from 'app/model/project-config-util';
import { ConfigAttribute, AttributeInfo, ProjectConfig, SupplementalAttribute } from 'app/types/project-config';
import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ChangeDetectorRef, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { Project } from 'app/model/project';
import { IDKeyTypes } from 'app/model/id-manager';

declare var dragula: any;
export type AttributePosition = {
  attributeId: number,
  at: number
}
export type AttributeListingSelection = {
  attribute: ConfigAttribute | SupplementalAttribute
  type: AttributeFeatureType;
}
@Component({
  selector: 'app-attribute-listing',
  templateUrl: './attribute-listing.component.html',
  styleUrls: ['./attribute-listing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributeListingComponent implements OnInit {

  private attStates = new StatefulCSS();
  private _project?: Project;
  private _lastUpdate = new Date();
  private _ready = false;
  @Input()
  set updated(when: Date) {
    if (!this._ready) {
      this._lastUpdate = when;
      return;
    }
    if (when !== this._lastUpdate) {
      const project = this._project;
      this._project = undefined;
      this.Refresh();
      window.requestAnimationFrame(() => {
        this._project = project;
        this.Refresh();
      });
    }
    this._lastUpdate = when;
  }
  @Input()
  set project(p: Project | undefined) {
    this._project = p;
    this.cdr.detectChanges();
  }
  get project(): Project | undefined {
    return this._project;
  }
  @Output()
  public projectChange = new EventEmitter<Project>();
  get projectConfig() {
    if (!this.project) return undefined;
    return this.project.config;
  }
  @Output()
  public selections = new EventEmitter<AttributeListingSelection>();
  public selectedType: '' | 'point' | 'segment' | 'supplemental' = '';
  public get pointAttributes(): Array<ConfigAttribute> {
    if (!this.projectConfig) return [];
    return this.projectConfig.attributes.point;
  }
  public get segmentAttributes(): Array<ConfigAttribute> {
    if (!this.projectConfig) return [];
    return this.projectConfig.attributes.segment;
  }
  public get supplementalAttributes(): Array<SupplementalAttribute> {
    if (!this.projectConfig) return [];
    if (!this.projectConfig.attributes.suppl) return [];
    return this.projectConfig.attributes.suppl;
  }
  @ViewChild('pointAtts') pointAtts!: ElementRef<HTMLDivElement>;
  @ViewChild('segmentAtts') segmentAtts!: ElementRef<HTMLDivElement>;
  @ViewChild('supplAtts') supplAtts!: ElementRef<HTMLDivElement>;

  @HostBinding('class.section') section = true;
  constructor(private cdr: ChangeDetectorRef,
    private messager: ModalMessagerService,
    private domNode: ElementRef) { }

  ngOnInit(): void {
    this._ready = true;
    this.attStates.SetPrefix('atts');
    this.attStates.AddState('none');
    this.attStates.AddState('point');
    this.attStates.AddState('segment');
    this.attStates.AddState('suppl');
    this.attStates.SetMachine(this.domNode.nativeElement);
    this.SetupDragula(this.pointAtts);
    this.SetupDragula(this.segmentAtts);
    this.SetupDragula(this.supplAtts);

    /*this.dragula.createGroup('point-attributes', {
      moves: (el?, container?, handle?) => {
        if (handle) {
          return handle.className === 'handle';
        }
        return false;
      }
    });*/
  }
  SetupDragula(target:ElementRef) {
    dragula([target.nativeElement, target.nativeElement],
      {
        moves: (_el?: any, _container?: any, handle?: any) => {
          if (handle) {
            return handle.classList.contains('handle');
          }
          return false;
        }
      }).on('drop', (el: HTMLDivElement) => {
        this.HandleAttributeDrop(el);
        el.classList.toggle('dragging',false);
      }).on('drag',(el:HTMLDivElement) => {
        el.classList.toggle('dragging',true);
      });
  }
  HandleAttributeDrop(el: HTMLDivElement) {
    const attPos: AttributePosition | false = this.GetAttributePosition(el);
    if (attPos === false) {
      return;
    }
    if (!(this.project && this.project.config)) return;
    let src:Array<ConfigAttribute> = [];
    const idType = this.project.idManager.IDType(Number(attPos.attributeId));
    switch (idType) {
      case IDKeyTypes.PointAttributes:
        src = this.project.config.attributes.point;
        break;
      case IDKeyTypes.SegmentAttributes:
        src = this.project.config.attributes.segment;
        break;
      case IDKeyTypes.Supplemental:
        src = this.project.config.attributes.suppl;
    }
    let offset = -1;
    src.every((att, index, src) => {
      if (att.id === attPos.attributeId) {
        const oldAtts = src.splice(index, 1);
        const oldAtt = (!!oldAtts) ? oldAtts.pop() : undefined;
        if (!oldAtt) return false;
        src.splice(attPos.at, 0, oldAtt);
        return false;
      }
      return true;
    });
    this.Refresh();
    this.NotifyProjectListeners();
  }
  GetAttributePosition(el: HTMLDivElement): AttributePosition | false {
    const elements: HTMLCollectionOf<HTMLDivElement> = this.pointAtts.nativeElement.getElementsByClassName('attribute') as HTMLCollectionOf<HTMLDivElement>;
    let previous = -1;
    for (const element of elements) {
      const id = Number(element.dataset['attId']);
      if (id === 0) {
        continue;
      }
      if (id === Number(el.dataset['attId'])) {
        const data = { attributeId: id, at: previous + 1 }
        return data;
      }
      previous += 1;
    }
    return false;
  }
  SelectPointAttribute(attr: ConfigAttribute): void {
    this.selections.emit({ attribute: attr, type: 'point' });
  }
  SelectSegmentAttribute(attr: ConfigAttribute) {
    this.selections.emit({ attribute: attr, type: 'segment' });
  }
  SelectSupplementalAttribute(attr: SupplementalAttribute) {
    this.selections.emit({ attribute: attr, type: 'suppl' });

  }
  HandleTypeChange() {
    switch (this.selectedType) {
      case 'point':
        this.attStates.SetState('point');
        break;
      case 'segment':
        this.attStates.SetState('segment');
        break;
      case 'supplemental':
        this.attStates.SetState('suppl');

        break;
    }
    this.Refresh();
  }
  Refresh() {
    this.cdr.detectChanges();
  }
  Add() {
    if (!this.project) {
      return;
    }
    switch (this.selectedType) {
      case 'point':
        this.project.CreateAttribute(IDKeyTypes.PointAttributes);
        break;
      case 'segment':
        this.project.CreateAttribute(IDKeyTypes.SegmentAttributes);
        break;
      case 'supplemental':
        this.project.CreateAttribute(IDKeyTypes.SupplementalAttributes);
        break;
    }
    this.NotifyProjectListeners();
  }
  Delete(attribute: ConfigAttribute | SupplementalAttribute) {
    if (!this.project) return;
    this.messager.Confirm('Deleting this attribute cannot be undone. Click Ok to delete, or Cancel to abort this action.',
      () => {
        this.project!.DeleteAttribute(attribute);
        this.cdr.detectChanges();
        this.NotifyProjectListeners();
      }, null);

  }
  NotifyProjectListeners() {
    this.projectChange.emit(this.project);
  }
}
